import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'

export const ServicesTitle = styled.div`
  color: ${colors.twilightBlue};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const ServicesList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin: 0;
  margin-top: 16px;
`

export const Content = styled.div`
  margin-top: 20px;

  ${mediaUp('md')} {
    margin-top: 48px;
  }
`
